module.exports = __webpack_public_path__ + "static/media/Test18.8f4f07fd.bmp";